var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSociusLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8218 1.76965C15.8218 1.06844 16.3902 0.5 17.0914 0.5L22.3653 0.500001C23.0665 0.500001 23.635 1.06844 23.635 1.76965C23.635 2.47085 23.0665 3.03929 22.3653 3.03929L17.0914 3.03929C16.3902 3.03929 15.8218 2.47085 15.8218 1.76965Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.26965 8.31321C0.56844 8.31321 -4.53782e-08 7.74477 1.59232e-08 7.04356L4.76984e-07 1.76965C5.38285e-07 1.06844 0.568441 0.5 1.26965 0.5C1.97085 0.5 2.53929 1.06844 2.53929 1.76965L2.53929 7.04356C2.53929 7.74477 1.97085 8.31321 1.26965 8.31321Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3653 16.3218C23.0665 16.3218 23.635 16.8902 23.635 17.5914L23.635 22.8653C23.635 23.5665 23.0665 24.135 22.3653 24.135C21.6641 24.135 21.0957 23.5665 21.0957 22.8653L21.0957 17.5914C21.0957 16.8902 21.6641 16.3218 22.3653 16.3218Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81321 22.8653C7.81321 23.5665 7.24477 24.135 6.54356 24.135L1.26965 24.135C0.56844 24.135 -1.53254e-07 23.5665 0 22.8653C1.53254e-07 22.1641 0.56844 21.5957 1.26965 21.5957L6.54356 21.5957C7.24477 21.5957 7.81321 22.1641 7.81321 22.8653Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59232e-08 7.04356C1.07875e-07 6.34236 0.56844 5.77392 1.26965 5.77392L6.54356 5.77392C7.24477 5.77392 7.81321 6.34236 7.81321 7.04357C7.81321 7.74477 7.24477 8.31321 6.54356 8.31321L1.26965 8.31321C0.56844 8.31321 -4.53782e-08 7.74477 1.59232e-08 7.04356Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0914 5.77392C17.7926 5.77392 18.361 6.34236 18.361 7.04356L18.361 12.3175C18.361 13.0187 17.7926 13.5871 17.0914 13.5871C16.3902 13.5871 15.8217 13.0187 15.8217 12.3175L15.8218 7.04356C15.8218 6.34236 16.3902 5.77392 17.0914 5.77392Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.635 17.5914C23.635 18.2926 23.0665 18.861 22.3653 18.861L17.0914 18.861C16.3902 18.861 15.8218 18.2926 15.8218 17.5914C15.8218 16.8902 16.3902 16.3217 17.0914 16.3217L22.3653 16.3218C23.0665 16.3218 23.635 16.8902 23.635 17.5914Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54356 18.861C5.84236 18.861 5.27392 18.2926 5.27392 17.5914L5.27392 12.3175C5.27392 11.6163 5.84236 11.0478 6.54357 11.0478C7.24477 11.0478 7.81321 11.6163 7.81321 12.3175L7.81321 17.5914C7.81321 18.2926 7.24477 18.861 6.54356 18.861Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3653 5.77392C23.0665 5.77392 23.635 6.34236 23.635 7.04356C23.635 10.6574 20.7052 13.5871 17.0914 13.5871C16.3902 13.5871 15.8217 13.0187 15.8217 12.3175C15.8217 11.6163 16.3902 11.0478 17.0914 11.0478C19.3028 11.0478 21.0957 9.25494 21.0957 7.04356C21.0957 6.34236 21.6641 5.77392 22.3653 5.77392Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27392 1.76965C5.27392 1.06844 5.84236 0.5 6.54356 0.5C10.1574 0.5 13.0871 3.42977 13.0871 7.04356C13.0871 7.74477 12.5187 8.31321 11.8175 8.31321C11.1163 8.31321 10.5478 7.74477 10.5478 7.04356C10.5478 4.83219 8.75494 3.03929 6.54356 3.03929C5.84236 3.03929 5.27392 2.47085 5.27392 1.76965Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.361 22.8653C18.361 23.5665 17.7926 24.135 17.0914 24.135C13.4776 24.135 10.5478 21.2052 10.5478 17.5914C10.5478 16.8902 11.1163 16.3218 11.8175 16.3218C12.5187 16.3218 13.0871 16.8902 13.0871 17.5914C13.0871 19.8028 14.88 21.5957 17.0914 21.5957C17.7926 21.5957 18.361 22.1641 18.361 22.8653Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.26965 18.861C0.56844 18.861 -2.43951e-08 18.2926 6.75571e-08 17.5914C5.41449e-07 13.9776 2.92977 11.0478 6.54357 11.0478C7.24477 11.0478 7.81321 11.6163 7.81321 12.3175C7.81321 13.0187 7.24477 13.5871 6.54356 13.5871C4.33219 13.5871 2.53929 15.38 2.53929 17.5914C2.53929 18.2926 1.97085 18.861 1.26965 18.861Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociusLogo);
export default __webpack_public_path__ + "static/media/socius_logo.e5a537981d94ef3b5e34007017f5fcd1.svg";
export { ForwardRef as ReactComponent };